<template>
<div>
    <v-snackbar v-model="error" color="red darken-2">
        <b>{{ errorMessage }} </b>
    </v-snackbar>
    <div v-if="this.employeeData">
        <v-card class="review-card">
            <template>
                <v-stepper v-model="genralStepperIndex" vertical light non-linear>
                    <!-- STEPPER 1 -->
                    <v-stepper-step id="step_1" @click="$vuetify.goTo('#step_1', options)" editable step="1" color="#00635b">
                        <b> {{ $t('pdr.title1') }} </b>
                    </v-stepper-step>

                    <!-- CONTENT OF STEPPER 1 -->
                    <v-stepper-content step="1">
                        <v-card class="mb-12">
                            <References :employeeData="employeeData"></References>
                        </v-card>
                        <v-btn color="red darken-2" class=" mb-3 mr-2" @click="printEmployeePDF" style="color: white !important;">
                            <v-icon class="mr-2">mdi-file-pdf-outline</v-icon> {{$t('pdr.reference.print')}}
                        </v-btn>
                        <v-btn class="mb-3" color="#00635b" style="color: white !important;" @click="genralStepperIndex = 2; ">{{$t('pdr.reference.beginAssessement')}} <v-icon>mdi-arrow-down</v-icon>
                        </v-btn>
                    </v-stepper-content>

                    <!-- STEPPER 2 -->
                    <v-stepper-step id="step_2" @click="$vuetify.goTo('#step_2', options)" editable step="2" color="#00635b"> <b>{{$t('pdr.part2.tit')}}</b></v-stepper-step>
                    <!-- CONTENT OF STEPPER 2 -->
                    <v-stepper-content step="2">

                        <v-card class="mb-12">
                            <!-- Info message : Part 1 and 2 -->
                            <v-alert class="mr-3 info-text " colored-border border="left" color="#00635b" type="info" elevation="4">
                                <v-card-text v-html="labels['PDR_PROCESS_'+locale.toUpperCase()]"> </v-card-text>
                            </v-alert>
                            <!-- OBJECTIVES 2018 CONTENT  CARD -->
                            <v-card flat>
                                <v-card-title class="secondary-titles" id="step_21" @click="$vuetify.goTo('#step_21', options)">
                                    <v-icon color="#8ba79d" class="mr-2">mdi-numeric-1-circle</v-icon> {{employeeData.campaign.year -1}} Objectives Assessment
                                </v-card-title>
                                <v-card-text class="ml-5">
                                    <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                       <v-card-text v-html="labels['OBJ_ASS_'+locale.toUpperCase()]"> </v-card-text>
                                    </v-alert>

                                    <!-- Tableau Objectives Assessment -->
                                    <template>
                                        <v-simple-table style="margin-top: 25px;">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="general-background">
                                                        <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.n')}}</b></th>
                                                            <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.ObjectiveName') }}</b></th>
                                                            <th class="text-left col-elem border-elem" rowspan="2" style="width: 40%;"><b>{{ $t('pdr.part2.Description')}}</b></th>
                                                            <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.Indicator')}}</b></th>
                                                            <th class="text-left col-elem border-elem" rowspan="2" style="width: 110px;"><b> {{$t('pdr.part2.Completion')}}</b></th>
                                                            <th class="text-left col-elem border-elem" rowspan="2"><b>{{ $t('pdr.part2.poids')}}</b></th>
                                                        <th class="text-left col-elem border-elem" colspan="2">
                                                            <b>{{ $t('pdr.reference.employee')}}</b>
                                                        </th>
                                                    </tr>
                                                    <tr class="general-background">
                                                        <th class="text-left col-elem border-elem" scope="col" style="width:10%;">{{ $t('pdr.part2.Achievement')}}</th>
                                                        <th class="text-left col-elem border-elem" scope="col" style="width: 20%;">{{ $t('pdr.part2.comments')}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="objective in employeeData.reviewFirstPart.objectivesEmployee" v-bind:key="objective.id">
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.id }}</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.name }}</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.description }}</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.successIndicator }}</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.completionDate | simpleDate }}</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">{{ objective.weighting }} %</td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">
                                                            <div class="mt-3 mb-3 ">{{ objective.slManagerAchievements }} %</div>
                                                        </td>
                                                        <td class="text-left border-elem-in-table pt-2 pb-2">
                                                            <div class="mt-3 mb-3">{{ objective.slManagerComments }}</div>
                                                        </td>
                                                    </tr>

                                                    <!-- FOOTER -->
                                                    <tr class="general-background">
                                                        <th class="text-left border-elem" colspan="6">{{$t('pdr.part2.GlobalAchievement')}}</th>
                                                        <th class="text-left border-elem" colspan="2">{{ GlobalAchivementRatePart1 }} %</th>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>

                                    <!-- Tableau Employee Self Assessment  -->
                                    <template>
                                        <v-simple-table class="margin-top">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="second-background">
                                                        <td class="text-center col-elem border-elem" rowspan="2">{{ $t('pdr.part2.n')}}</td>
                                                            <th class="text-left col-elem border-elem" colspan="2" scope="colgroup">{{$t('pdr.part2.EmployeeSelf')}}</th>
                                                    </tr>
                                                    <tr class="second-background">
                                                        <th class="text-left col-elem border-elem" scope="col" style="width: 120px;">{{$t('pdr.part2.Achievement')}}</th>
                                                            <th class="text-left col-elem border-elem" scope="col" style="width: 90%;">{{$t('pdr.part2.comments')}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="objective in employeeData.reviewFirstPart.objectivesEmployee" v-bind:key="objective.id">
                                                        <td class="text-left border-elem-in-table">{{ objective.id }}</td>
                                                        <td class="text-center border-elem-in-table">{{ objective.employeeAchievements }}%</td>
                                                        <td class="text-left border-elem-in-table">{{ objective.employeeComments }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-card-text>
                            </v-card>
                            <br>
                            <!-- ASSESSING PERFORMANCE CONTENT CARD  -->
                            <v-card flat>
                                <v-card-title class="secondary-titles" id="step_22" @click="$vuetify.goTo('#step_22', options)">
                                    <v-icon color="#8ba79d" class="mr-2">mdi-numeric-2-circle</v-icon> {{$t('pdr.part2.AssessingPerformance')}}
                                </v-card-title>
                                <v-card-text class=" ml-5">
                                    <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                        <v-card-text v-html="labels['ASS_PERF_'+locale.toUpperCase()]"> </v-card-text>
                                    </v-alert>
                                    <template>
                                        <v-simple-table style="overflow:hidden; margin-top: 25px;">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="second-table-general-header">
                                                        <th class="text-left col-elem" colspan="3" id="skills" @click="$vuetify.goTo('#skills', options)" style="cursor: pointer"><b>{{$t('pdr.part2.Skills')}}</b></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <!-- TECHNICAL SKILLS -->
                                                    <tr class="second-table-specific-header">
                                                        <th class="text-left col-elem-specific-header" colspan="3" id="technical_skills" @click="$vuetify.goTo('#technical_skills', options)" style="cursor: pointer"><b>{{$t('pdr.part2.TechnicalSkills')}}</b></th>
                                                    </tr>
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2" style="width: 50%">{{$t('pdr.part2.Assess')}}</td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0; width: 25%">
                                                            {{ selectedTechnicalSkill }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedTechnicalSkillManager }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.technicalSkillsComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.technicalSkillsComment }}</div>
                                                        </td>
                                                    </tr>

                                                    <!-- CULTURE AND VALUES -->
                                                    <tr class="second-table-specific-header">
                                                        <th class="text-left col-elem-specific-header" id="culture_values" @click="$vuetify.goTo('#culture_values', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.Culture')}}</b></th>
                                                    </tr>

                                                    <!-- First -->
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem-in-table" rowspan="2">
                                                            <p class="mt-2">
                                                                <b>{{$t('pdr.part2.Value1')}}</b> <br> <br>
                                                                <ul>
                                                                    <li>{{$t('pdr.part2.Value1Part1')}}</li>
                                                                    <li>{{$t('pdr.part2.Value1Part2')}}</li>
                                                                </ul>
                                                            </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedCustomerCentric }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedCustomerCentricManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="text-left border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.customerCentricComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.customerCentricComment }}</div>
                                                        </td>
                                                    </tr>
                                                    <div></div>
                                                    <!-- Second -->
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                            <p class="mt-2">
                                                                    <b>{{$t('pdr.part2.Value2')}}</b> <br> <br>
                                                                    <ul>
                                                                        <li>{{$t('pdr.part2.Value2Part1')}}</li>
                                                                        <li>{{$t('pdr.part2.Value2Part2')}}</li>
                                                                    </ul>
                                                                </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedFeelingvalued }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedFeelingvaluedManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">
                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.feelingValuedComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.feelingValuedComment }}</div>
                                                        </td>
                                                    </tr>

                                                    <div></div>
                                                    <!-- Third -->
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                           <p class="mt-2">
                                                                    <b>{{$t('pdr.part2.Value3')}}</b> <br> <br>
                                                                    <ul>
                                                                        <li>{{$t('pdr.part2.Value3Part1')}}</li>
                                                                        <li>{{$t('pdr.part2.Value3Part2')}}</li>
                                                                    </ul>
                                                                </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedOpenCommunication }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedOpenCommunicationManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.openCommunicationComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.openCommunicationComment }}</div>
                                                        </td>
                                                    </tr>

                                                    <div></div>
                                                    <!-- Fourth -->
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                           <p class="mt-2">
                                                                    <b>{{$t('pdr.part2.Value4')}}</b> <br> <br>
                                                                    <ul>
                                                                        <li>{{$t('pdr.part2.Value4Part1')}}</li>
                                                                        <li>{{$t('pdr.part2.Value4Part2')}}</li>
                                                                    </ul>
                                                                </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedWorkingTogether }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedWorkingTogetherManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.workingTogetherComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.workingTogetherComment }}</div>
                                                        </td>
                                                    </tr>

                                                    <!-- LEADERSHIP -->
                                                    <tr class="second-table-specific-header">
                                                        <th class="text-left col-elem-specific-header" id="leadership" @click="$vuetify.goTo('#leadership', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.Leadership')}}</b></th>
                                                    </tr>

                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                            <p class="mt-2">
                                                                <ul>
                                                                        <li>{{$t('pdr.part2.Engageandinspire')}}</li>
                                                                            <li>{{$t('pdr.part2.Provideandcommunicat')}}</li>
                                                                            <li>{{$t('pdr.part2.Seetheglobal')}}</li>
                                                                            <li>{{$t('pdr.part2.Takesinitiative')}}</li>
                                                                            <li>{{$t('pdr.part2.Supportandstimulate')}}</li>
                                                                            <li>{{$t('pdr.part2.Leadthetransformation')}}</li>
                                                                    </ul>
                                                            </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedLeadership }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedLeadershipManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.leadershipComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.leadershipComment }}</div>
                                                        </td>
                                                    </tr>

                                                    <!-- EXECUTION EXCELLENCE -->
                                                    <tr class="second-table-specific-header">
                                                        <th class="text-left col-elem-specific-header" id="execution_excellence" @click="$vuetify.goTo('#execution_excellence', options)" colspan="3" style="cursor: pointer"><b>{{$t('pdr.part2.ExecutionExcellence')}}</b></th>
                                                    </tr>

                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                            <p class="mt-2">
                                                                    <ul>
                                                                        <li>{{$t('pdr.part2.Setchallengingobjectives')}}</li>
                                                                            <li>{{$t('pdr.part2.Continuallystrives')}}</li>
                                                                    </ul>
                                                                </p>

                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedExectionExcellence }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedExectionExcellenceManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.executionExcellence }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.executionExcellence }}</div>
                                                        </td>
                                                    </tr>

                                                    <!-- OVERALL PERFORMANCE -->
                                                    <tr class="second-table-general-header">
                                                        <th class="text-left col-elem" colspan="3" id="overall_performance" @click="$vuetify.goTo('#overall_performance', options)" style="cursor: pointer"><b>{{$t('pdr.part2.OverallPerformance')}}</b></th>
                                                    </tr>
                                                    <tr class="no-hover-row">
                                                        <td class="text-left border-elem" rowspan="2">
                                                            {{$t('pdr.part2.Pleaseratetheoverall')}}
                                                        </td>

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ selectedOverallPerformance }}
                                                        </td>

                                                        <td class="border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ selectedOverallPerformanceManager }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr class="no-hover-row">

                                                        <td class="border-elem-in-table" style="background-color: #f0f0f0">
                                                            {{ employeeData.reviewFirstPart.assessingEmployeeDto.overallPerformanceComment }}
                                                        </td>

                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3">{{ employeeData.reviewFirstPart.assessingManagerDto.overallPerformanceComment }}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-card-text>
                            </v-card>
                            <br>
                            <!-- NOTIFICATION PDR -->
                            <v-card flat>
                                <v-card-title class="secondary-titles" id="step_23" @click="$vuetify.goTo('#step_23', options)">
                                    {{$t('pdr.part2.NotificationPDR')}}
                                </v-card-title>
                                <v-card-text>
                                    <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                       {{$t('pdr.part2.Thissection')}} 
                                    </v-alert>

                                    <template>
                                        <v-simple-table style="margin-top: 25px;">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                            <th class="text-left col-elem border-elem"><b></b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Task')}}</b></th>
                                                                <th class="text-center col-elem border-elem general-background" style="width: 5%"><b>{{$t('pdr.part2.Signature')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Date')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background" style="width: 50%;"><b>{{$t('pdr.part2.Commentsshared')}}</b></th>
                                                        </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-left border-elem general-background">{{$t('pdr.reference.slmanager')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                        <td class="text-center border-elem-in-table">
                                                            <v-icon v-if="employeeData.reviewFirstPart.slmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                            <v-icon v-else>mdi-clock-outline</v-icon>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.slmanagerDate | simpleDate }}</td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div> {{ employeeData.reviewFirstPart.slmanagerComment }} </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                       <td class="text-left border-elem general-background">{{$t('pdr.reference.dlmanager')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                        <td class="text-center border-elem-in-table">
                                                            <v-icon v-if="employeeData.reviewFirstPart.dlmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                            <v-icon v-else>mdi-clock-outline</v-icon>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.dlmanagerDate | simpleDate }}</td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div v-if="employeeData.reviewFirstPart.dlmanagerSigned">{{ employeeData.reviewFirstPart.dlmanagerComment }} </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left border-elem general-background">{{$t('pdr.reference.employee')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                        <td class="text-center border-elem-in-table">
                                                            <v-icon v-if="employeeData.reviewFirstPart.employeeSigned" color="success">mdi-check-bold</v-icon>
                                                            <v-icon v-else>mdi-clock-outline</v-icon>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">{{ employeeData.reviewFirstPart.employeeDate | simpleDate }}</td>
                                                        <td class="text-left border-elem-in-table"> {{ employeeData.reviewFirstPart.employeeComment }} </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-card-text>
                            </v-card>
                        </v-card>
                        <v-btn class="ml-2 mb-3" color="#00635b" style="color: white !important;" @click="genralStepperIndex = 3">{{$t('pdr.part2.NEXT')}} <v-icon>mdi-arrow-down</v-icon>
                        </v-btn>
                        <v-btn class=" ml-2 mb-3" color="grey lighten-3" @click="genralStepperIndex = 1">{{$t('pdr.part2.PREVIOUS')}} <v-icon>mdi-arrow-up</v-icon>
                        </v-btn>

                        <!-- SNACKBAR Part 1 - 2 -->
                        <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
                            <b>{{ snackBarText }} </b>
                        </v-snackbar>
                    </v-stepper-content>

                    <!-- STEPPER 3 -->
                    <v-stepper-step editable step="3" color="#00635b" id="step_3" @click="$vuetify.goTo('#step_3', options)"><b>{{$t('pdr.part3.title')}}</b> </v-stepper-step>
                    <!-- CONTENT OF STEPPER 3 -->
                    <v-stepper-content step="3">
                        <v-card color="grey lighten-5" class="mb-12">
                            <v-alert class="mr-3 info-text " colored-border border="left" color="#00635b" type="info" elevation="4">
                                <v-card-text v-html="labels['PDR_PROCESS_'+locale.toUpperCase()]"> </v-card-text>
                            </v-alert>

                            <!--  OBJECTIVE SETTING  -->
                            <v-card flat>
                                <v-card-title class="secondary-titles" id="step_31" @click="$vuetify.goTo('#step_31', options)">
                                    <v-icon color="#8ba79d" class="mr-2">mdi-numeric-3-circle</v-icon> {{$t('pdr.part3.Objectivessettings')}}
                                </v-card-title>
                                <v-card-text class="ml-5">
                                    <v-alert class="mr-3 mb-5 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                            <v-card-text v-html="labels['OBJ_SETTINGS_'+locale.toUpperCase()]"> </v-card-text>
                                    </v-alert>

                                    <v-row justify="center">
                                        <v-btn rounded style="color: white; background-color:#8ba79d;" class="mb-10" @click="showHideObjectivesEMployee()">
                                            <span v-if="!showEmployeeProposal">Show</span> <span v-else>Hide</span>&nbsp;{{$t('pdr.part3.EmployeeProposal')}}
                                        </v-btn>
                                    </v-row>

                                    <div v-if="showEmployeeProposal" class="mb-10">
                                        <h5><b style="color: #8ba79d;">{{$t('pdr.part3.EmployeeProposal')}}</b></h5>
                                        <template>
                                            <v-simple-table style="margin-top: 15px;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr class="second-background">
                                                                <th class="text-left col-elem border-elem"><b>{{ $t('pdr.part2.ObjectiveName')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width: 40%;"><b>{{ $t('pdr.part2.Description')}}</b></th>
                                                                <th class="text-left col-elem border-elem"><b>{{ $t('pdr.part2.Indicator')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width: 200px;"><b>{{ $t('pdr.part2.Completion')}}</b></th>
                                                                <th class="text-left col-elem border-elem" style="width:10%;"><b>{{ $t('pdr.part2.poids')}}</b></th>
                                                            </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="objective in employeeData.reviewSecondPart.objectivesEmployee" v-bind:key="objective.id">
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 ">{{ objective.name }}</div>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 ">{{ objective.description }}</div>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 ">{{ objective.successIndicator }}</div>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 "> {{ objective.completionDate }}</div>

                                                            </td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3 ">{{ objective.weighting }}</div>
                                                            </td>
                                                        </tr>
                                                        <!-- FOOTER -->
                                                        <tr class="second-background">
                                                            <th class="text-right border-elem" style="color: white" colspan="4">{{$t('pdr.part3.TotalWeight')}}</th>
                                                            <th class="text-left border-elem" style="color: white" colspan="2">{{ GlobalAchivementRatePart2Employee }} %</th>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                    </div>

                                    <h5><b style="color: #8ba79d;">{{$t('pdr.part3.SLManagerProposal')}}</b></h5>

                                    <template>
                                        <v-simple-table style="margin-top: 15px;">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="general-background">
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.part2.ObjectiveName')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 40%;"><b>{{$t('pdr.part2.Description')}}</b></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.part2.Indicator')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 200px;"><b>{{$t('pdr.part2.Completion')}}</b></th>
                                                            <th class="text-left col-elem border-elem" style="width: 120px;"><b>{{$t('pdr.part2.poids')}}</b></th>
                                                            <th class="text-center col-elem border-elem" style="width: 100px;"><b>{{ $t('pdr.part2.Action')}}</b></th>
                                                        </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="objective in employeeData.reviewSecondPart.objectivesManager" v-bind:key="objective.id">
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 ">{{ objective.name }}</div>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 ">{{ objective.description }}</div>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 ">{{ objective.successIndicator }}</div>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 "> {{ objective.completionDate }}</div>
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 ">{{ objective.weighting }}</div>
                                                        </td>
                                                    </tr>
                                                    <!-- FOOTER -->
                                                    <tr class="general-background">
                                                        <th class="text-right border-elem" colspan="4">{{$t('pdr.part3.TotalWeight')}}</th>
                                                        <th class="text-left border-elem" colspan="2">{{ GlobalAchivementRatePart2Manager }} %</th>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-card-text>
                            </v-card>

                            <!-- CAREER DEVELOPMENT -->
                            <v-card flat>
                                <v-card-title class="secondary-titles" id="step_32" @click="$vuetify.goTo('#step_32', options)">
                                    <v-icon color="#8ba79d" class="mr-2">mdi-numeric-4-circle</v-icon> {{$t('pdr.part3.CareerDevelopmentPlan')}}
                                </v-card-title>
                                <v-card-text class="ml-5">

                                    <!-- Message d'alert -->
                                    <v-alert class="mr-3 mb-10 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                       {{$t('pdr.part3.Pleaseindicate')}}
                                    </v-alert>

                                    <h5><b style="color: #8ba79d;">{{$t('pdr.part3.Wouldyou')}}</b></h5>

                                    <!-- CHECKBOXES OF CAREER DP -->
                                    <template>
                                        <v-card class="mr-3">
                                            <v-card-text>
                                                <!-- Georgraphical -->
                                                <div>
                                                    <span style="font-size: 16px">{{$t('pdr.part3.Geographical')}}
                                                        <v-icon v-if="employeeData.reviewSecondPart.careerDP.geographical" color="success">mdi-check-bold</v-icon>
                                                        <v-icon v-else color="error">mdi-close</v-icon>
                                                    </span>
                                                </div>

                                              <template>
                                                <v-card outlined class="mr-3 ml-7 mt-5" v-if="employeeData.reviewSecondPart.careerDP.geographical" style="width: 40%">
                                                  <v-card-text>
                                                    <v-row>
                                                      <v-col>
                                                        <span class="mb-0" style="color: #212121">{{$t('pdr.part3.MOBILITY_RANGE')}}</span>
                                                      </v-col>
                                                      <v-col>
                                                        <span v-if="employeeData.reviewSecondPart.careerDP.mobilityRange">{{ employeeData.reviewSecondPart.careerDP.mobilityRange }}</span>
                                                      </v-col>
                                                    </v-row>
                                                  </v-card-text>
                                                </v-card>
                                              </template>

                                                <!-- Functional -->
                                                <div class="mt-5">
                                                    <span style="font-size: 16px">{{$t('pdr.part3.Functional')}}
                                                        <v-icon v-if="employeeData.reviewSecondPart.careerDP.functional" color="success">mdi-check-bold</v-icon>
                                                        <v-icon v-else color="error">mdi-close</v-icon>
                                                    </span>
                                                </div>

                                                <template>
                                                    <template>
                                                        <v-card outlined class="mr-3 ml-7 mt-5" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col>
                                                                        <span class="mb-0" style="color: #212121">{{$t('pdr.part3.Forwhattype')}}</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <span>{{ employeeData.reviewSecondPart.careerDP.position }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-text>
                                                        </v-card>
                                                    </template>

                                                    <!-- <template>
                                                        <v-card outlined class="mr-3 ml-7 mt-3" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col>
                                                                        <span class="mb-0" style="color: #212121"> For which Business Unit(s) ?</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <ul>
                                                                            <li v-for="b in chosenBu" v-bind:key="b">
                                                                                {{ b }}
                                                                            </li>
                                                                        </ul>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-text>
                                                        </v-card>
                                                    </template> -->

                                                    <template>
                                                        <v-card outlined class="mr-3 ml-7 mt-3" v-if="employeeData.reviewSecondPart.careerDP.functional" style="width: 40%">
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col>
                                                                        <span class="mb-0" style="color: #212121"> {{$t('pdr.part3.Forwhich')}}</span>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <ul>
                                                                            <li v-for="f in chosenFunctions" v-bind:key="f">
                                                                                {{ f }}
                                                                            </li>
                                                                        </ul>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-text>

                                                        </v-card>
                                                    </template>
                                                </template>

                                                <!-- Last select of checkboxs sections (TIMEFRAME) -->
                                                <template>
                                                    <v-card outlined class="mt-3 mr-3" v-if="employeeData.reviewSecondPart.careerDP.functional ||  employeeData.reviewSecondPart.careerDP.geographical" style="width: 40%">
                                                        <v-card-text>
                                                            <v-row>
                                                                <v-col>
                                                                    <span class="mb-0" style="color: #212121">{{$t('pdr.part3.Whatwouldbe')}}</span>
                                                                </v-col>
                                                                <v-col>
                                                                    <span>{{ employeeData.reviewSecondPart.careerDP.timeframeMobility }}</span>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                            </v-card-text>
                                        </v-card>
                                    </template>

                                    <br>
                                    <h5><b style="color: #8ba79d;">{{$t('pdr.part3.Commentsonmobility')}}</b></h5>
                                    <template>
                                        <v-simple-table>
                                            <template>
                                                <thead>
                                                    <tr class="general-background">
                                                        <th class="text-left col-elem border-elem" style="width: 50%"><b>{{$t('pdr.reference.employee')}}</b></th>
                                                        <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.slmanager')}}</b></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="border-elem">
                                                            {{ employeeData.reviewSecondPart.careerDP.commentsEmployee }}
                                                        </td>
                                                        <td class="border-elem">
                                                            <span class="mt-3 mb-3 mr-3">{{ employeeData.reviewSecondPart.careerDP.commentsManager }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>

                                    <br>
                                    <h5><b style="color: #8ba79d;">{{$t('pdr.part3.DevelopmentPlan')}}</b></h5>
                                    <v-alert class="mr-3 mb-10 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                        <v-card-text v-html="labels['DEV_PLAN_'+locale.toUpperCase()]"> </v-card-text>
                                    </v-alert>
                                    <template>
                                    </template>
                                    <template>
                                        <v-simple-table style="margin-top: 25px;">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="general-background">
                                                        <th style="background-color: white !important"></th>
                                                        <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.employee')}}</b></th>
                                                            <th class="text-left col-elem border-elem"><b>{{$t('pdr.reference.slmanager')}}</b></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-left border-elem general-background">{{$t('pdr.part3.70')}}</td>
                                                        <td class="text-left border-elem-in-table" style="width: 40%">
                                                            {{ employeeData.reviewSecondPart.careerDP.dpFirstItemEmployee }}
                                                        </td>
                                                        <td class="text-left border-elem-in-table" style="width: 40%">
                                                            <div class="mt-3 mb-3 mr-3">{{ employeeData.reviewSecondPart.careerDP.dpFirstItemManager }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left border-elem general-background">{{$t('pdr.part3.20')}}</td>
                                                        <td class="text-left border-elem-in-table">
                                                            {{ employeeData.reviewSecondPart.careerDP.dpSecondItemEmployee }}
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 mr-3">{{ employeeData.reviewSecondPart.careerDP.dpSecondItemManager }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left border-elem general-background">{{$t('pdr.part3.10')}}</td>
                                                        <td class="text-left border-elem-in-table">
                                                            {{ employeeData.reviewSecondPart.careerDP.dpThirdItemEmployee }}
                                                        </td>
                                                        <td class="text-left border-elem-in-table">
                                                            <div class="mt-3 mb-3 mr-3">{{ employeeData.reviewSecondPart.careerDP.dpThirdItemManager }}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-card-text>

                                <!-- NOTIFICATION PDR PART 3-4 -->
                                <v-card flat>
                                    <v-card-title class="secondary-titles" id="step_33" @click="$vuetify.goTo('#step_33', options)">
                                       {{$t('pdr.part2.NotificationPDR')}}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-alert class="mr-3 info-text margin-top" border="left" colored-border color="#8ba79d" type="info" elevation="4">
                                            {{$t('pdr.part2.Thissection')}}
                                        </v-alert>

                                        <template>
                                            <v-simple-table style="margin-top: 25px;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                                <th class="text-left col-elem border-elem"><b></b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Task')}}</b></th>
                                                                <th class="text-center col-elem border-elem general-background" style="width: 5%"><b>{{$t('pdr.part2.Signature')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background"><b>{{$t('pdr.part2.Date')}}</b></th>
                                                                <th class="text-left col-elem border-elem general-background" style="width: 50%;"><b>{{$t('pdr.part2.Commentsshared')}}</b></th>
                                                            </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.reference.slmanager')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                            <td class="text-center border-elem-in-table">
                                                                <v-icon v-if="employeeData.reviewSecondPart.slmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                <v-icon v-else>mdi-clock-outline</v-icon>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.slmanagerDate | simpleDate }}</td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div class="mt-3 mb-3">{{ employeeData.reviewSecondPart.slmanagerComment }}</div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.reference.dlmanager')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                            <td class="text-center border-elem-in-table">
                                                                <v-icon v-if="employeeData.reviewSecondPart.dlmanagerSigned" color="success">mdi-check-bold</v-icon>
                                                                <v-icon v-else>mdi-clock-outline</v-icon>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.dlmanagerDate | simpleDate }}</td>
                                                            <td class="text-left border-elem-in-table">
                                                                <div v-if="employeeData.reviewSecondPart.dlmanagerSigned">{{ employeeData.reviewSecondPart.dlmanagerComment }} </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-left border-elem general-background">{{$t('pdr.reference.employee')}}</td>
                                                            <td class="text-left border-elem-in-table">{{$t('pdr.part2.PDRformvalidation')}}</td>
                                                            <td class="text-center border-elem-in-table">
                                                                <v-icon v-if="employeeData.reviewSecondPart.employeeSigned" color="success">mdi-check-bold</v-icon>
                                                                <v-icon v-else>mdi-clock-outline</v-icon>
                                                            </td>
                                                            <td class="text-left border-elem-in-table">{{ employeeData.reviewSecondPart.employeeDate | simpleDate }}</td>
                                                            <td class="text-left border-elem-in-table">
                                                                {{ employeeData.reviewSecondPart.employeeComment }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-card>
                        </v-card>

                        <v-btn class=" ml-2 mb-3" color="grey lighten-3" @click="genralStepperIndex = 2">
                            {{$t('pdr.part2.PREVIOUS')}} <v-icon>mdi-arrow-up</v-icon>
                        </v-btn>

                        <!-- SNACKBAR Part 3 - 4 -->
                        <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="snackBarTimeout">
                            <b>{{ snackBarText }} </b>
                        </v-snackbar>
                    </v-stepper-content>

                </v-stepper>
            </template>
            <br>
        </v-card>
    </div>
</div>
</template>

<style>
.margin-top {
    margin-top: 15px;
}

.review-card {
    margin-top: 113px;
}

.general-background {
    background-color: #00635b !important;
    color: white !important;
}

.second-background {
    background-color: #8ba79d !important;
}

.secondary-titles {
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
}

.secondary-titles:hover {
    background-color: #f0f0f0
}

.col-elem {
    color: white !important;

}

.border-elem {
    border: 2px solid white
}

.info-text {
    font-style: italic;
}

.second-table-general-header {
    background-color: #3f3a40;
}

.second-table-general-header:hover {
    background-color: #3f3a40 !important;
}

.second-table-specific-header {
    border-bottom: 3px solid #00635b;
}

.col-elem-specific-header {
    color: #00635b !important;

}

.no-hover-row:hover {
    background-color: white !important;

}

.delete-button:hover {
    color: red;
}

table {
    overflow: hidden !important;
}

label {
    margin-bottom: 0px !important;
}
</style>

<script>
import References from '@/components/References.vue'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'DLManagerReview',
    components: {
        References
    },
    data() {
        return {
            error: false,
            errorMessage: '',
            AcceptedPartOneAndTwo: false,
            AcceptedPartThreeAndFour: false,
            employeeData: null,
            assessingEmployee: null,
            reviewFirstPartToSybmit: null,
            yearOfReview: null,
            showEmployeeProposal: false,
            statusIsDlValidationPart1_2: false,
            statusIsDlValidationPart3_4: false,
            showButtonSignPart1_2: false,
            showButtonSignPart3_4: false,
            GlobalAchivementRatePart1: 0,
            
            selectedTechnicalSkill: '',
            selectedTechnicalSkillManager: '',

            
            selectedCustomerCentric: '',
            selectedFeelingvalued: '',
            selectedOpenCommunication: '',
            selectedWorkingTogether: '',
            selectedLeadership: '',
            selectedExectionExcellence: '',

            selectedCustomerCentricManager: '',
            selectedFeelingvaluedManager: '',
            selectedOpenCommunicationManager: '',
            selectedWorkingTogetherManager: '',
            selectedLeadershipManager: '',
            selectedExectionExcellenceManager: '',

            
            selectedOverallPerformance: '',
            selectedOverallPerformanceManager: '',
           
            availableBU: [],
            chosenBu: [],
            availableFunctions: [],
            chosenFunctions: [],
            modelAvailableBU: [],
            modelChosenBU: [],
            modelAvailableFunction: [],
            modelChosenFunction: [],
            GlobalAchivementRatePart2Employee: 0,
            GlobalAchivementRatePart2Manager: 0,
            genralStepperIndex: 1,
            Stepper2Index: 1,
            Stepper3Index: 1,
            dateFormatted: null,
            duration: 400,
            offset: 113,
            easing: 'easeInOutCubic',
            snackbar: false,
            snackBarText: '',
            snackBarColor: '',
            snackBarTimeout: 2000,
        }
    },
    filters: {
        simpleDate: function (value) {
            if (!value) return ''
            const [year, month, day] = value.split('-')
            return `${day}/${month}/${year}`
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        getYearOfReview(year) {
            return (+year);
        },
        calculateTotalWeight() {
            let varTemp2 = 0;

            this.employeeData.reviewSecondPart.objectivesManager.forEach(function (element) {
                varTemp2 += +element.weighting;
            });
            this.GlobalAchivementRatePart2Manager = varTemp2;
        },
        getGlobalAchivement(tab) {
            let varToReturn = 0;
            if (tab) {
                tab.forEach(function (element) {
                    varToReturn +=  ((+element.weighting) * (+element.slManagerAchievements)) / 100;
                    
                })
            }
            return parseFloat(varToReturn.toFixed(2));
        },
        showHideObjectivesEMployee() {
            this.showEmployeeProposal = !this.showEmployeeProposal
        },

        availabaleBuToChosenBu() {

            for (let i = 0; i < this.modelAvailableBU.length; i++) {
                this.chosenBu.push(this.availableBU[this.modelAvailableBU[i]]);
            }

            for (let i = 0; i < this.chosenBu.length; i++) {

                var index = this.availableBU.indexOf(this.chosenBu[i]);
                if (index > -1) {
                    this.availableBU.splice(index, 1);
                }
            }

            this.modelAvailableBU = [];
        },

        chosenBuToAvailableBu() {

            for (let i = 0; i < this.modelChosenBU.length; i++) {
                this.availableBU.push(this.chosenBu[this.modelChosenBU[i]]);
            }

            for (let i = 0; i < this.availableBU.length; i++) {

                var index = this.chosenBu.indexOf(this.availableBU[i]);
                if (index > -1) {
                    this.chosenBu.splice(index, 1);
                }
            }

            this.modelChosenBU = [];
        },
        availabaleFunctionToChosenFunction() {

            for (let i = 0; i < this.modelAvailableFunction.length; i++) {
                this.chosenFunctions.push(this.availableFunctions[this.modelAvailableFunction[i]]);
            }

            for (let i = 0; i < this.chosenFunctions.length; i++) {

                var index = this.availableFunctions.indexOf(this.chosenFunctions[i]);
                if (index > -1) {
                    this.availableFunctions.splice(index, 1);
                }
            }

            this.modelAvailableFunction = [];
        },

        chosenFunctionToAvailableFunction() {

            for (let i = 0; i < this.modelChosenFunction.length; i++) {
                this.availableFunctions.push(this.chosenFunctions[this.modelChosenFunction[i]]);
            }

            for (let i = 0; i < this.availableFunctions.length; i++) {

                var index = this.chosenFunctions.indexOf(this.availableFunctions[i]);
                if (index > -1) {
                    this.chosenFunctions.splice(index, 1);
                }
            }

            this.modelChosenFunction = [];
        },

        // METHODE D'IMPRESSION DU PDF
        printEmployeePDF: function () {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var myMethod = "post";
            fetch(process.env.VUE_APP_ROOT_API_PATH + "api/pdf/general?userId=" + this.employeeData.user.id + "&year=" + this.employeeData.campaign.year, {
                    method: myMethod,
                    credentials: 'include',
                    headers: myHeaders,
                }).then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.target = "_Blank"
                    a.href = url;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },
    },
    watch: {
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    computed: {
        positionItems() {
            return ["", this.$t('pdr.part3.Headquarter'), this.$t('pdr.part3.OperationsCountries'), this.$t('pdr.part3.HeadquarterorOperations')]},
        timeframeMobilityItems() {
            return ["", this.$t('pdr.part3.Shortterm'), this.$t('pdr.part3.Mediumterm'), this.$t('pdr.part3.Longterm')]},
        overallPerformanceItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Performancebelow')
              }, {
                key: 2,
                value: this.$t('pdr.part2.Performanceatrequired')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Goodlevelofperformance')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Exceptionnalperformance')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        cultureAndValuesItems() {
            return  [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Developmentrequired')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Developmentopportunity')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Meetsexpectations')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Strength')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        technicalSkillsItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {

                key: 1,
                value: this.$t('pdr.part2.Donotmaster')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Partiallymasters')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Masters')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Perfectlymasters')
              },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        leadershipItems() {
            return [
              {
                key: 0,
                value: ""
              },
              {
                key: 1,
                value: this.$t('pdr.part2.Developmentrequired')
              },
              {
                key: 2,
                value: this.$t('pdr.part2.Developmentopportunity')
              },
              {
                key: 3,
                value: this.$t('pdr.part2.Meetsexpectations')
              },
              {
                key: 4,
                value: this.$t('pdr.part2.Strength')
              },
              {
                key: 5,
                value: "N/A"
            },
              {
                key: 6,
                value: this.$t('pdr.part2.NEW_SKILS.DoesNotMeet')
              },
              {
                key: 7,
                value: this.$t('pdr.part2.NEW_SKILS.PartiallyMeets')
              },
              {
                key: 8,
                value: this.$t('pdr.part2.NEW_SKILS.Meets')
              },
              {
                key: 9,
                value: this.$t('pdr.part2.NEW_SKILS.MeetsAndExceeds')
              },
              {
                key: 10,
                value: this.$t('pdr.part2.NEW_SKILS.Outstanding')
              },
              {
                key: 11,
                value: this.$t('pdr.part2.NEW_SKILS.NA')
              }
            ]},
        options() {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing,
            }
        },
        ...mapGetters({
            labels: "getLabels",
            user: "auth/user",
            locale: "getLocale",
        }),

    },
    mounted: function () {
        this.user.langue;
        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/reviews/" + this.$route.params.id, {
                method: "get",
                credentials: 'include'
            })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                this.employeeData = response.data;
                this.employeeData.reviewFirstPart.type = "manager";
                this.employeeData.reviewFirstPart.employee = {};
                this.employeeData.reviewFirstPart.slManager = {};
                this.employeeData.reviewFirstPart.dlManager = {};
                this.employeeData.reviewFirstPart.employee.id = this.employeeData.user.id;

                if (this.employeeData.SLmanager) {
                    this.employeeData.reviewFirstPart.slManager.id = this.employeeData.SLmanager.id;
                }
                if (this.employeeData.DLmanager) {
                    this.employeeData.reviewFirstPart.dlManager.id = this.employeeData.DLmanager.id;
                }

                if (this.employeeData.reviewFirstPart.status.code === "DLM_VAL" || this.employeeData.reviewFirstPart.status.code === "EMP_NOTIF") {
                    this.statusIsDlValidationPart1_2 = true;
                } else {
                    this.statusIsDlValidationPart1_2 = false;
                }

                this.employeeData.reviewSecondPart.type = "manager";
                this.employeeData.reviewSecondPart.employee = {};
                this.employeeData.reviewSecondPart.slManager = {};
                this.employeeData.reviewSecondPart.dlManager = {};
                this.employeeData.reviewSecondPart.employee.id = this.employeeData.user.id;
                if (this.employeeData.SLmanager) {
                    this.employeeData.reviewSecondPart.slManager.id = this.employeeData.SLmanager.id;
                }
                if (this.employeeData.DLmanager) {
                    this.employeeData.reviewSecondPart.dlManager.id = this.employeeData.DLmanager.id;
                }

                if (this.employeeData.reviewSecondPart.status.code === "DLM_VAL" || this.employeeData.reviewSecondPart.status.code === "EMP_NOTIF") {
                    this.statusIsDlValidationPart3_4 = true;
                } else {
                    this.statusIsDlValidationPart3_4 = false;
                }

                if (this.employeeData.reviewFirstPart.dlmanagerSigned) {
                    this.AcceptedPartOneAndTwo = true;
                }

                if (this.employeeData.reviewSecondPart.dlmanagerSigned) {
                    this.AcceptedPartThreeAndFour = true;
                }

                this.assessingEmployee = this.employeeData.reviewFirstPart.assessingEmployeeDto;
                this.assessingManager = this.employeeData.reviewFirstPart.assessingManagerDto;

                this.calculateTotalWeight();

                let varTemp1 = 0;
                this.employeeData.reviewSecondPart.objectivesEmployee.forEach(function (element) {
                    varTemp1 += +element.weighting;
                });
                this.GlobalAchivementRatePart2Employee = varTemp1;

                //get l'année de la review à afficher
                this.yearOfReview = this.getYearOfReview(this.employeeData.campaign.year);

                // get global achievement rate Part 1
                this.GlobalAchivementRatePart1 = this.getGlobalAchivement(this.employeeData.reviewFirstPart.objectivesEmployee);

                // Gestion des selects
                this.selectedTechnicalSkill = this.technicalSkillsItems.find(i => i.key === this.assessingEmployee.technicalSkillsRating).value
                this.selectedCustomerCentric = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.customerCentricRating).value
                this.selectedFeelingvalued = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.feelingValuedRating).value
                this.selectedOpenCommunication = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.openCommunicationRating).value
                this.selectedWorkingTogether = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.workingTogetherRating).value
                this.selectedLeadership = this.leadershipItems.find(i => i.key === this.assessingEmployee.leadershipRating).value
                this.selectedExectionExcellence = this.cultureAndValuesItems.find(i => i.key === this.assessingEmployee.executionExcellenceRating).value
                this.selectedOverallPerformance = this.overallPerformanceItems.find(i => i.key === this.assessingEmployee.overallPerformanceRating).value

                this.selectedTechnicalSkillManager = this.technicalSkillsItems.find(i => i.key === this.assessingManager.technicalSkillsRating).value
                this.selectedCustomerCentricManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.customerCentricRating).value
                this.selectedFeelingvaluedManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.feelingValuedRating).value
                this.selectedOpenCommunicationManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.openCommunicationRating).value
                this.selectedWorkingTogetherManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.workingTogetherRating).value
                this.selectedLeadershipManager = this.leadershipItems.find(i => i.key === this.assessingManager.leadershipRating).value
                this.selectedExectionExcellenceManager = this.cultureAndValuesItems.find(i => i.key === this.assessingManager.executionExcellenceRating).value
                this.selectedOverallPerformanceManager = this.overallPerformanceItems.find(i => i.key === this.assessingManager.overallPerformanceRating).value

                // gestion des tableau Available/Chosen
                if (this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit != null) {
                    this.availableBU = this.employeeData.reviewSecondPart.careerDP.availableBusinessUnit;
                }

                if (this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit != null) {
                    this.chosenBu = this.employeeData.reviewSecondPart.careerDP.choosenBusinessUnit;
                }

                if (this.employeeData.reviewSecondPart.careerDP.availableGroupFunction != null) {
                    this.availableFunctions = this.employeeData.reviewSecondPart.careerDP.availableGroupFunction;
                }

                if (this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction != null) {
                    this.chosenFunctions = this.employeeData.reviewSecondPart.careerDP.choosenGroupFunction;
                }
                 this.$store.dispatch("setAdditionalMessage", this.$t('pdr.Performancereview')+ " " + this.yearOfReview + " " + this.$t('pdr.of') + " " + response.data.user.firstName + " " + response.data.user.lastName);

            });
    }
}
</script>
